/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Ex } from './Ex';

class OrderInvoice extends Ex {
    constructor() {
        super();
        this.baseUrl += '/orderInvoice';
    }

    data(queryData) {
        let invoiceBeginTime = null;
        let invoiceEndTime = null;
        if (queryData.invoiceTime != null && queryData.invoiceTime.length === 2) {
            [invoiceBeginTime, invoiceEndTime] = queryData.invoiceTime;
        }
        return super.get('/data', {
            ...queryData,
            invoiceBeginTime,
            invoiceEndTime,
        });
    }

    getDetail({ id } = {}) {
        return super.get('/get', { id });
    }

    complete1({ id } = {}) {
        return super.post('/complete1', {
            id,
        });
    }

    complete2({ id, expressId, trackingNumber } = {}) {
        return super.post('/complete2', {
            id,
            expressId,
            trackingNumber,
        });
    }

    invalid({ id } = {}) {
        return super.post('/invalid', {
            id,
        });
    }

    returnInvoice({ id, refundAmount } = {}) {
        return super.post('/returnInvoice', {
            id,
            refundAmount,
        });
    }

    cancel({ id } = {}) {
        return super.post('/cancel', {
            id,
        });
    }

    reQuery({ ids }) {
        return super.post('/reQuery', { ids });
    }

    paperBilling({ id }) {
        return super.post('/paperBilling', {
            id,
        });
    }

    paperReturnBilling({ id, refundAmount }) {
        return super.post('/paperReturnBilling', {
            id,
            refundAmount,
        });
    }

    paperInvoiceCancellation({ id }) {
        return super.post('/paperInvoiceCancellation', {
            id,
        });
    }

    paperReQuery({ ids }) {
        return super.post('/paperReQuery', {
            ids,
        });
    }

    save({
        id,
        invoiceTitle,
        taxIdentificationSn,
        invoiceRemarks,
        bankName,
        bankAccount,
        registerAddress,
        registerTel,
    }) {
        return super.post('/save', {
            id,
            invoiceTitle,
            taxIdentificationSn,
            invoiceRemarks,
            bankName,
            bankAccount,
            registerAddress,
            registerTel,
        });
    }

    nullifyOfflineQRCode({ id } = {}) {
        return super.post('/nullifyOfflineQRCode', {
            id,
        });
    }

    offlineReturnBilling({ id, refundAmount } = {}) {
        return super.post('/offlineReturnBilling', {
            id,
            refundAmount,
        });
    }

    offlineInvoiceCancellation({ id } = {}) {
        return super.post('/offlineInvoiceCancellation', {
            id,
        });
    }
}

export default new OrderInvoice();
export { OrderInvoice };
